// @ts-nocheck

import React from 'react';
import type { Node } from 'react';
import styled, { css } from 'styled-components';

const StyledButton = styled.button`
  && {
    border-radius: 1.5em;
    border: none;
    height: 3em;
    min-width: 6em;
    padding: 0 1em;
    font-family: BettingPoliticaExtraBold, sans-serif;
    font-weight: 800;
    text-transform: uppercase;
    cursor: pointer;

    &:active {
      transform: scale(0.9);
    }

    ${({ $isDisabled, theme }) =>
      $isDisabled
        ? css`
            color: ${theme.grids.colors.middlegrey1};
            background-color: ${theme.grids.colors.darkgrey3};
          `
        : css`
            color: #fff;
            background-color: ${theme.grids.colors.redlight};
          `}
  }
`;

type Props = {
  className?: string;
  children: Node;
  onClick?: () => void;
  isDisabled?: boolean;
  'data-testid'?: string; // to pass data-testid via styled-components :(
};

const Primary = (props: Props) => {
  const { className, children, onClick, isDisabled = false } = props;
  return (
    <StyledButton $isDisabled={isDisabled} onClick={onClick} className={className} data-testid={props['data-testid']}>
      {children}
    </StyledButton>
  );
};

export default Primary;
